import { render, staticRenderFns } from "./PainelItemTabela.vue?vue&type=template&id=46d2cf7c"
import script from "./PainelItemTabela.vue?vue&type=script&lang=js"
export * from "./PainelItemTabela.vue?vue&type=script&lang=js"
import style0 from "./PainelItemTabela.vue?vue&type=style&index=0&id=46d2cf7c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports